import FlowMonitor from '@ssr/lib/flowMonitor'

const flowMonitor = new FlowMonitor()

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => flowMonitor.reset())
}

export default flowMonitor
